import React, { Component } from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";
import "./Donut.style.scss";

class Donut extends Component {
  state = {
    margin: { top: 20, right: 20, bottom: 30, left: 40 },
    legends: [],
  };
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    data: PropTypes.array.isRequired,
  };

  componentDidMount() {
    const { margin } = this.state;
    const { id, width, label, height, data } = this.props;
    this.setLegends({ data });
    this.drawChart({ margin, data, id, width, height, label });
  }

  componentWillReceiveProps(nextProps) {
    const { margin } = this.state;
    const { id, width, label, height, data } = nextProps;
    if (
      JSON.stringify(data) !== JSON.stringify(this.props.data) ||
      width !== this.props.width
    ) {
      this.setLegends({ data });
      this.drawChart({ margin, data, id, width, height, label });
    }
  }

  setLegends = ({ data = [] }) => {
    if (!data && data.length === 0) return;
    let list = [];

    for (let i = 0; i < data.length; i++) {
      let obj = {};
      let val = data[i]["value"];
      obj["name"] = data[i]["name"];
      obj["value"] = val;
      // obj["color"] = this.color(val);
      obj["color"] = data[i]["color"];
      list.push(obj);
    }
    this.setState({
      legends: list,
    });
  };
  color = d3.scale
    .ordinal()
    .range([
      "#5262ad",
      "#6372b5",
      "#7581bd",
      "#8691c6",
      "#97a1ce",
      "#a9b1d6",
      "#bac0de",
      "#cbd0e6",
      "#dce0ef",
      "#eeeff7",
    ]);
  drawChart = ({ margin, data = [], id, width, height, label }) => {
    if (!data && data.length === 0) return;
    d3.select(`#${id}`).selectAll("svg").remove();

    var w = width - margin.left - margin.right,
      h = height - margin.top - margin.bottom;

    const r = Math.min(w, h) / 2;

    let svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", w + margin.left + margin.right)
      .attr("height", h + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    var arc = d3.svg
      .arc()
      .innerRadius(r - 80)
      .outerRadius(r - 20);

    var pie = d3.layout.pie().value(function (d) {
      return d;
    });

    var arcs = svg
      .selectAll(".arcc")
      .data(pie(data.map((e) => e.value)))
      .enter()
      .append("g")
      .attr("class", "arcc");

    let path = arcs.append("path").attr("fill", (d, i) => data[i]["color"]);

    path
      .append("title")
      .text(
        (d, i) =>
          `${
            data[i]["name"] ? data[i]["name"] : "Unallocated"
          } : ${d.value.toFixed(2)}%`
      );
    path.transition().duration(800).attr("d", arc); // here the arc function works on every record d of data

    // .attrTween("d", tweenPie);

    var donutTip = d3
      .select(`#${id}`)
      .append("div")
      .attr("class", "donut-tip")
      .style("opacity", 0);

    d3.select(`#${id}`).selectAll("path");
    // .on("mouseover", (d, i) => {
    //   donutTip.transition().duration(50).style("opacity", 1);
    //   let num = Math.round((d.value / d.data.all) * 100).toString() + "%";
    //   donutTip
    //     .html(num)
    //     .style("left", d3.event.pageX + 10 + "px")
    //     .style("top", d3.event.pageY - 15 + "px");
    // })
    // .on("mouseout", function (d, i) {
    //   donutTip.transition().duration("50").style("opacity", 0);
    // });

    // .append("title")
    // .data(pie(data.map((e) => e.value)))
    // .text((d, i) => {
    //   console.log({ d, i, data });
    //   // return `${data[i]["name"]} : ${d.value} %`;
    //   return `${d.value} %`;
    // });

    function tweenPie(b) {
      let i = d3.interpolate(
        {
          startAngle: 2 * Math.PI,

          endAngle: 2 * Math.PI,
        },
        b
      );
      return (t) => arc(i(t));
    }

    arcs
      .append("text")
      .attr("transform", function (d) {
        return "translate(" + arc.centroid(d) + ")";
      }) // put text at the center of every arc
      .attr("text-anchor", "middle")
      .attr("font-size", "1.2em")
      .style("fill", "#fff")
      .text(function (d) {
        if (d.data) {
          return `${d.data.toFixed(2)}%`;
        }
      });

    // center text
    if (label && label.length > 0) {
      let txt = svg.append("text").attr("text-anchor", "middle").style({
        "text-transform": "Uppercase",
        "font-size": "1.2em",
        "font-weight": "bold",
        fill: "#676767",
      });
      let split = label.split(" ");
      split.map((e, i) => {
        return txt
          .append("tspan")
          .text(e)
          .attr("x", 0)
          .attr("y", i * 20 - (split.length <= 3 ? 10 : 20));
      });
    }
  };

  Legends = ({ data }) => {
    if (data && data.length > 0) {
      return (
        <div className="donut_chart_legend">
          {data.map((e, i) => {
            if (e.name && e.value > 0) {
              return (
                <div key={i}>
                  <div
                    style={{
                      backgroundColor: e.color,
                      width: "5px",
                      height: "5px",
                    }}
                  ></div>
                  <div>{e.name}</div>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      );
    }
  };
  render() {
    const { legends } = this.state;
    const { id, allocationWarningMsg } = this.props;
    return (
      <div className="donut_chart_holder">
        {allocationWarningMsg && (
          <div className="donut_chart_holder_warning">
            Please make sure allocations are adding upto 100%.
          </div>
        )}

        <div id={id} className="donut_chart_holder_main"></div>
        {this.Legends({ data: legends })}
      </div>
    );
  }
}

export default Donut;



// WEBPACK FOOTER //
// ./src/components/d3Components/donut/Donut.jsx